export const HEADERS = {
    branch_code : 'Code',
    branch_name : 'Branch Name',
    address : 'Address',
    pincode: "Pincode",
    service_category : "Service Category",
    cost_center :"Cost Center",
    created_by : 'Created By',
    created_on : 'Last Create Date',
    updated_by : 'Updated By',
    updated_on : 'Updated Date',
    actions : 'Edit/Delete'
}

export const branchConstants = {
    title: "Branches",
    add_title: "New Branch",
    edit_title: "Edit Branch",
    table_header: {
      branch_name: "Branch Name",
      code: "Code",
      city: "City",
      address: "Address",
      created_by: "Created By",
      created_on: "Created On",
      modified_by: "Modified By",
      modified_on: "Modified On",
      edit_delete: "Edit / Delete"
    },
    create: {
      title: "Add Branch",
      branch_name: {
        title: "Branch Name",
        placeholder: "Branch Name",
        error_msg: {
          required: "Required",
          name: "Name enter is incorrect !"
        }
      },
      city: {
        title: "City",
        placeholder: "Select City",
        error_msg: {
          required: "Required",
          name: "City is required !"
        }
      },
      address: {
        title: "Address",
        placeholder: "Address",
        error_msg: {
          required: "Required",
          name: "Address is required !"
        }
      },
      pincode: {
        title: "Pincode",
        placeholder: "Pincode",
      },
      pan_no : {
        title:"PAN Number",
        placeholder:"PAN Number"
      },
      state:{
        title:"State",
        placeholder:"Select State",
        name_placeholder :"State Name"
      },
      branch_code: {
        title: "Branch Code",
        placeholder: "Branch Code",
        error_msg: {
          required: "Required",
          name: "Code enter is incorrect !"
        }
      },
      gst_title : "GST Details",
      service_category_title : "Service Category Details",
      is_gst_applicable : {
        title:"Is GST Applicable"
      },
      gst_no : {
        title : "Gst Number",
        placeholder :"GST Number",
        error_msg : {
          required : "Required"
        }
      },
      is_gst_exempted : {
        title:"Is GST Exempted"
      },
      exempted_reason : {
        title :"Gst Exempted Reason",
        placeholder :"--SELECT A REASON--"
      },
      charge_mechanism : {
        title :"Charge Mechanism",
        placeholder : "Select Charge Mechanism"
      },
      service_category : {
        title :"Service Category",
        placeholder : "Select Service Category"
      },
      cost_center : {
        title :"Cost Center",
        placeholder : "Cost Center"
      },
      start_date : {
        title : "Validity Start Date"
      },
      end_date : {
        title : "Validity End Date"
      },
      action_button: {
        cancel :"Cancel",
        submit: "Submit"
      }
    }
  }